import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import React from "react";

const useStyles = createStyles({
  wrapper: {
    border: `1px solid ${tokens.color.semantic.border.faint}`,
    borderRadius: tokens.radius.md,
    overflow: "hidden",
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    "& a": {
      color: tokens.color.semantic.text.link,
    },
  },
  footer: {
    display: "flex",
    borderTop: `1px solid ${tokens.color.semantic.border.faint}`,
    backgroundColor: tokens.color.semantic.bg.surface,
  },
});

interface RpiTableV2ContainerProps extends React.PropsWithChildren {
  "aria-label"?: string;
  "data-testid"?: string;
}

export function RpiTableV2Container({ children, ...rest }: RpiTableV2ContainerProps) {
  const { classes } = useStyles();
  return (
    <div className={classes.wrapper} {...rest}>
      {children}
    </div>
  );
}

export function RpiTableFooter({ children }: React.PropsWithChildren) {
  const { classes } = useStyles();
  return <div className={classes.footer}>{children}</div>;
}
